import FormControlWithFloatingLabel from 'views/components/molecules/FormControlWithFloatingLabel'

const TextareaWithFloatingLabel = props => (
  <FormControlWithFloatingLabel {...props} formControl="textarea" />
)

TextareaWithFloatingLabel.propTypes = FormControlWithFloatingLabel.propTypes
TextareaWithFloatingLabel.defaultProps = {
  ...FormControlWithFloatingLabel.defaultProps,
  rows: 2,
}

export default TextareaWithFloatingLabel
